// ChangaPets — script propio. Un solo archivo, vanilla JS.
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleriaProducto();
  initVariantesProducto();
});

function initReveal() {
  var els = document.querySelectorAll('.cp-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('cp-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.getAttribute('data-cp-delay') || 0;
        setTimeout(function () { entry.target.classList.add('cp-visible'); }, Number(delay));
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-cp-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-cp-imagen-principal]');
  var miniaturas = galeria.querySelectorAll('[data-cp-miniatura]');
  miniaturas.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var full = mini.getAttribute('data-cp-full');
      var alt = mini.getAttribute('data-cp-alt') || '';
      if (principal && full) {
        principal.setAttribute('src', full);
        principal.setAttribute('alt', alt);
      }
      miniaturas.forEach(function (m) { m.classList.remove('cp-miniatura-activa'); });
      mini.classList.add('cp-miniatura-activa');
    });
  });
}

function initVariantesProducto() {
  var form = document.querySelector('[data-cp-form-producto]');
  if (!form) return;
  var dataEl = document.querySelector('[data-cp-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var selects = form.querySelectorAll('[data-cp-opcion]');
  var idInput = form.querySelector('input[name="id"]');
  var precioEl = document.querySelector('[data-cp-precio-actual]');
  var precioTachadoEl = document.querySelector('[data-cp-precio-tachado]');
  var botonComprar = form.querySelector('[data-cp-boton-comprar]');

  function opcionesSeleccionadas() {
    var seleccion = [];
    selects.forEach(function (sel) { seleccion.push(sel.value); });
    return seleccion;
  }

  function actualizar() {
    var seleccion = opcionesSeleccionadas();
    var match = variantes.find(function (v) {
      return v.options.every(function (val, i) { return val === seleccion[i]; });
    });
    if (!match) return;
    if (idInput) idInput.value = match.id;
    if (precioEl) precioEl.textContent = match.price_formatted;
    if (precioTachadoEl) {
      if (match.compare_at_price_formatted) {
        precioTachadoEl.textContent = match.compare_at_price_formatted;
        precioTachadoEl.style.display = '';
      } else {
        precioTachadoEl.style.display = 'none';
      }
    }
    if (botonComprar) {
      if (match.available) {
        botonComprar.disabled = false;
        botonComprar.textContent = botonComprar.getAttribute('data-cp-texto-disponible');
      } else {
        botonComprar.disabled = true;
        botonComprar.textContent = botonComprar.getAttribute('data-cp-texto-agotado');
      }
    }
  }

  selects.forEach(function (sel) { sel.addEventListener('change', actualizar); });
  actualizar();
}
